import * as React from 'react';
import { Stack } from 'office-ui-fabric-react';
import { jsx as _jsx } from "react/jsx-runtime";
export const CheckboxContainer = props => {
  return /*#__PURE__*/_jsx(Stack, {
    tokens: {
      padding: '30px 0 0 0'
    },
    children: props.children
  });
};